// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__5oRUb","file":"styles_file__AC0UZ"};